module.exports = __webpack_public_path__ + "img/water.a9d572f2.png";